<template>
  <!-- ↓ header -->
  <header class="l-header">
    <h1 class="l-header__logo">
      <span class="l-header__logo-item" v-if="!isKokoBuild">
        <img src="@/assets/img/logo/main.svg" alt="FL-UX" />
      </span>
      <span class="l-header__logo-item" v-if="isMbpBuild">
        <img src="@/assets/img/logo/mbp.svg" alt="MBP" />
      </span>
    </h1>
    <span class="language-select-box">
      <label class="language-select-label" :for="ids['language-select']">{{
        t('common.languages')
      }}</label>
      <select :id="ids['language-select']" class="language-select" :value="locale" v-model="locale">
        <option class="language-select-option" value="ja">日本語</option>
        <option class="language-select-option" value="en">English</option>
        <option class="language-select-option" value="es">Spanish</option>
        <option class="language-select-option" value="fr">French</option>
        <option class="language-select-option" value="pt-pt">Portuguese</option>
        <option class="language-select-option" value="de">Deutsch</option>
        <option class="language-select-option" value="it">Italian</option>
      </select>
    </span>
    <!-- <nav class="l-navigation">
          <ul class="l-navigation__lists">
            <li class="l-navigation__list"><a class="l-navigation__list-link" href="https://www.run-edge.com/dummy">お知らせ</a></li>
            <li class="l-navigation__list"><a class="l-navigation__list-link" href="https://www.run-edge.com/dummy">FL-UXとは</a></li>
            <li class="l-navigation__list"><a class="l-navigation__list-link" href="https://www.run-edge.com/dummy">特徴と機能</a></li>
            <li class="l-navigation__list"><a class="l-navigation__list-link" href="https://www.run-edge.com/dummy">事例</a></li>
            <li class="l-navigation__list"><a class="l-navigation__list-link" href="https://www.run-edge.com/dummy">選ばれる理由</a></li>
            <li class="l-navigation__list"><a class="l-navigation__list-link" href="https://www.run-edge.com/dummy">料金</a></li>
            <li class="l-navigation__list"><a class="l-navigation__list-link" href="https://www.run-edge.com/dummy">ログイン</a></li>
            <li class="l-navigation__list"><a class="l-navigation__list-link -active" href="https://www.run-edge.com/dummy">JP</a> / <a class="l-navigation__list-link" href="https://www.run-edge.com/dummy">EN</a></li>
            <li class="l-navigation__list -regist"><a class="l-navigation__list-button" href="https://www.run-edge.com/dummy">登録はこちら</a></li>
          </ul>
        </nav> -->
    <!-- <a class="c-hamburger" href="https://www.run-edge.com/dummy">
          <span class="c-hamburger__line -top"></span>
          <span class="c-hamburger__line -middle"></span>
          <span class="c-hamburger__line -bottom"></span>
        </a> -->
  </header>
  <!-- ↑ header -->
</template>

<script lang="ts">
import { computed, defineComponent, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import useId from '@/Hooks/useId'
import { setLocale } from '@vee-validate/i18n'
import StoreUtil from '@/stores/StoreUtil'

export default defineComponent({
  name: 'Header',
  setup() {
    const ids = useId(['language-select'])
    const { t, locale } = useI18n()
    const localeWatcher = watch(locale, () => {
      setLocale(locale.value)
    })
    const enterAccountStore = StoreUtil.useStore('EnterAccountStore')

    /**
     * 教育向け（KOKO）ビルドかどうか
     */
    const isKokoBuild = computed(() => {
      return process.env.VUE_APP_BUILD_TARGET === 'koko'
    })

    /**
     * MBP向けビルドかどうか
     */
    const isMbpBuild = computed(() => {
      return process.env.VUE_APP_BUILD_TARGET === 'mbp' || enterAccountStore.isMbpOrg
    })

    return {
      ids,
      locale,
      t,
      localeWatcher,
      isKokoBuild,
      isMbpBuild,
    }
  },
})
</script>

<style scoped lang="scss">
.language-select-box {
  background-color: inherit;
  color: white;
  position: absolute;
  right: 10px;
}
.language-select-label {
  margin-right: 3px;
}
.language-select {
  background-color: inherit;
  color: white;
}
</style>
